define('shared/initializer/form/adapters/mixins/CrossDomainSender',[
    '$',
    'shared/lib/RSVP',
    'shared/lib/URI',
    'shared/lib/console',
    'shared/util/state',
    'shared/initializer/form/constants',
    'shared/util/state/adapters/form',
    'shared/util/state/adapters/order',
    'shared/util/state/adapters/page',
    'shared/util/state/adapters/session',
    'shared/util/state/adapters/tracking',
    'shared/util/state/adapters/pending',
    'shared/util/state/adapters/user',
    'shared/util/Domain'
],
function (
    $,
    RSVP,
    URI,
    console,
    state,
    constants,
    formAdapter,
    orderAdapter,
    pageAdapter,
    sessionAdapter,
    trackingAdapter,
    pendingAdapter,
    userAdapter,
    Domain
) {
    'use strict';

    var LOG_NAME = 'shared/initializer/form/adapters/mixins/DomainCrossable:';
    var PATH_TRANSPORT = '/etc/designs/b2c/others/cross-domain-transport.html';
    var win = window;

    function getNextUrlElement() {
        var me = this;
        var $form = me.$form;
        return $form.find('input[name=' + constants.FIELD.OnSuccessUrl + ']');
    }

    function isGoingToCross() {
        var $next = getNextUrlElement.call(this);
        var nextUrl = $next.val();

        if ($next.length < 0 || nextUrl == null || nextUrl === '') {
            return false;
        }

        var anchor = win.document.createElement('a');
        anchor.href = nextUrl;

        var uriNext = new URI(anchor.href);

        if (uriNext.host() == null ||
            uriNext.host() === '' ||
            uriNext.host() === win.location.host) {
            return false;
        }

        return true;
    }

    function handleBeforeCross() {
        var me = this;
        var $next = getNextUrlElement.call(me);
        var nextUrl = $next.val();
        var stateObject;

        if (!isGoingToCross.call(me)) {
            return RSVP.resolve();
        }

        var uriNext = new URI(nextUrl);

        console.log(LOG_NAME, 'Preparing for domain crosing...');

        var currentDomain = new Domain(win.location.hostname);

        if (!currentDomain.is.subOf(Domain.ENGLISHTOWN_SEO)) {
            console.warn(LOG_NAME,
                'You may want to review and double check the next url,' +
                ' it is crossing domain');
        }

        return RSVP
            .resolve()
            .then(function(){
                return RSVP.all([
                    state.adapters.add(formAdapter),
                    state.adapters.add(pageAdapter),
                    state.adapters.add(sessionAdapter),
                    state.adapters.add(trackingAdapter),
                    state.adapters.add(pendingAdapter),
                    state.adapters.add(userAdapter)
                ]);
            })
            .then(function(){
                return state.push('session.fromEnglishTownDomain', true);
            })
            .then(function(){
                return state.get('');
            })
            .then(function(value){
                stateObject = value[0];
                var etag = stateObject.page.etag;
                var ptn = stateObject.page.partner_code;
                var key, lower;
                var parameters = uriNext.search(true);

                for(key in parameters) {
                    lower = key.toLowerCase();
                    switch(lower) {
                        case 'ptn':
                        case 'etag':
                            delete parameters[key];
                            break;
                        default:
                    }
                }

                parameters.ptn = ptn;
                parameters.etag = etag;

                uriNext.search(parameters);

                return currentDomain.get.secure();
            })
            .then(function(secured){
                uriNext.host(secured);
                return RSVP.resolve(uriNext.toString());
            })
            .then(function(newNextUrl){
                return new RSVP.Promise(function(resolve){
                    $next.val(newNextUrl);

                    var targetOrigin = uriNext.protocol() + '://' + uriNext.host();
                    var iframe = win.document.createElement('iframe');

                    iframe.onload = function(){
                        resolve({
                            iframe: iframe,
                            targetOrigin: targetOrigin
                        });
                    };
                    iframe.style.position = 'absolute';
                    iframe.style.left = '-9999px';
                    iframe.src = targetOrigin +
                        PATH_TRANSPORT + '?ts=' + Date.now();
                    win.document.body.appendChild(iframe);
                });
            })
            .then(function(value){
                return new RSVP.Promise(function(resolve, reject){
                    var iframe = value.iframe;
                    var targetOrigin = value.targetOrigin;
                    var target = iframe.contentWindow;
                    var postHandler;

                    $(window).on('message', function(evt){
                        var originEvent = evt.originalEvent;

                        if (originEvent == null ||
                            originEvent.data == null ||
                            originEvent.data.purpose !== 'domain-crossable') {
                            return;
                        }

                        if (originEvent.data.data === true) {
                            resolve();
                        }
                        else {
                            reject();
                        }

                        win.document.body.removeChild(iframe);
                        win.clearTimeout(postHandler);
                    });

                    function loop(){
                        target.postMessage({
                            value: stateObject,
                            purpose: 'domain-crossable'
                        }, targetOrigin);

                        postHandler = win.setTimeout(loop, 300);
                    }

                    loop();
                });
            });
    }

    function Ctor() {

    }

    var p = Ctor.prototype;

    p.doBeforeSubmit = function() {
        return handleBeforeCross.call(this);
    };

    return Ctor;
});

